import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Button from "../../../componentes/button/button";
import CargaEntregaService from "../../../services/resource/escalaDeRotaService";
import DropDown from "../../../componentes/dropdown/dropdown";
import Input from "../../../componentes/input/input";
import Multiselect from "../../../componentes/multiselect/multiselect";
import ButtonRadio from "../../../componentes/button-radio/button-radio";
import DateMasked from "../../../componentes/inputMask/DateMasked";
import { useAuth } from "../../../context/authContext";
import InputFormat from "../../../componentes/inputMask/inputMask";

function CadastrarEscalaRota({ onClose, auxiliares, motoristas, veiculos, filiais }) {
    const { user } = useAuth();

    const initialValues = {
        "id": null,
        "carga": null,
        "data": null,
        "cracha": null,
        "transporte": null,
        "area": "",
        "totalEntregas": null,
        "volume": null,
        "cubos": null,
        "capCubos": null,
        "distanciaPlanejada": null,
        "ocupacao": null,
        "tempoTotal": null,
        "motoristaId": null,
        "veiculoId": null,
        "auxiliares": [],
        "filialId": user.filialId,
        "filialNome": ""
    }

    const cargaService = new CargaEntregaService();

    const [form, setForm] = useState(initialValues);
    const [loading, setLoading] = useState(false);
    const [erros, setErros] = useState(false);
    const [errosV, setErrosV] = useState({
        motorista: false,
        auxiliares: false,
        veiculo: false
    })

    useEffect(() => {
        document.title = "MyDash | Planejamento"
    }, []);

    useEffect(() => {
        if (form.filialId != null) {
            setCampo('veiculoId', null);
            setCampo('motoristaId', null);
            setCampo('veiculoId', null);
            setCampo('auxiliares', []);
        }
    }, [form.filialId]);

    useEffect(() => {
        if (form.veiculoId && form.dataOperacao) {
            const data = {
                dataOperacao: form.dataOperacao,
                cargaId: form.id,
                veiculoId: form.veiculoId
            };

            cargaService.validaVeiculo(data).then(res => {
                setErr('veiculo', res.data)
            });

        }else {
            setErr('veiculo', false)
        }
    }, [form.veiculoId, form.dataOperacao])

    useEffect(() => {
        if (form.auxiliares.length >= 1 && form.dataOperacao) {

            const promises = form.auxiliares.map(aux => {
                const data = {
                    dataOperacao: form.dataOperacao,
                    cargaId: form.id,
                    auxiliarId: aux.id
                };

                return cargaService.validadAuxiliar(data);
            });

            Promise.all(promises).then(results => {
                const temErro = results.some(res => res.data === true);
                setErr('auxiliares', temErro);
            });

        } else {
            setErr('auxiliares', false);
        }

    }, [form.auxiliares, form.dataOperacao]);

    useEffect(() => {
        if (form.motoristaId && form.dataOperacao) {
            const data = {
                dataOperacao: form.dataOperacao,
                cargaId: form.id || null,
                motoristaId: form.motoristaId
            };

            cargaService.validaMotorista(data).then(res => {
                setErr('motorista', res.data)
            });
        } else {
            setErr('motorista', 'false')
        }
    }, [form.motoristaId, form.dataOperacao])

    const setErr = (campo, valor) => {
        setErrosV(prev => ({
            ...prev,
            [campo]: valor
        }));
    };

    const handleSalvar = async () => {
        setLoading(true);

        try {

            let response;
            response = await cargaService.cadastrarCarga(form);
            toast.success("Carga cadastrada com sucesso!");

            onClose(response.data);

        } catch (e) {
            setErros(true);
            console.error("Erro ao salvar.", e);
        } finally {
            setLoading(false);
        }
    };

    const setCampo = (campo, valor) => {
        setForm(prev => ({
            ...prev,
            [campo]: valor
        }));
    };

    return (
        <div className="flex flex-col gap-5 pt-4 w-full space-y-6">
            <div className="p-1 grid grid-cols-2 md:grid-cols-6 gap-3">
                <DropDown
                    label="Filial"
                    optional
                    disabled={user.perfis.includes('COMISSOES')}
                    className="w-full text-xs border"
                    optionLabel="nome"
                    optionValue="id"
                    name="filialId"
                    options={filiais}
                    value={form.filialId}
                    filter={false}
                    onChange={e => setCampo('filialId', e.value)}
                    error={form.filialId === null && erros}
                    touched={erros}
                />

                <DateMasked
                    label="Data de Saída"
                    value={form.dataOperacao}
                    onChange={e => setCampo("dataOperacao", e)}
                    error={(form.dataOperacao === null || form.dataOperacao === "") && erros}
                    touched={erros}
                />

                <Input
                    label="Carga"
                    value={form.carga}
                    onChange={e => setCampo("carga", e.target.value)}
                    error={form.carga === null && erros}
                    touched={erros}
                />

                <DropDown
                    label="Veículo"
                    value={form.veiculoId}
                    options={veiculos}
                    itemTemplate={(item) => <div>
                        {item.placa} <span className="text-muted-foreground text-xs">{item.codigoYork}</span>  <span className="text-muted-foreground text-xs">{item.codigoSolar}</span>
                    </div>
                    }
                    optionValue="id"
                    optionLabel="placa"
                    nullValue
                    filter
                    onChange={(e) => setCampo("veiculoId", e.target.value)}
                    showClear
                    placeholder="Selecione o motorista"
                    required
                    error={(errosV.veiculo === true ? "Veículo Vinculado em Outra Carga" : null) || erros}
                    touched={erros || errosV.veiculo}
                />

                <Input
                    label="Cracha"
                    value={form.cracha}
                    onChange={e => setCampo("cracha", e.target.value)}
                />

                <Input
                    label="Transporte"
                    required

                    type="number"
                    value={form.transporte}
                    onChange={e => setCampo("transporte", e.target.value)}
                    error={form.transporte === null || erros}
                    touched={erros}
                />

                <div className="md:col-span-2">
                    <DropDown
                        label="Motorista"
                        required
                        value={form.motoristaId}
                        options={motoristas}
                        optionValue="id"
                        optionLabel="nome"
                        itemTemplate={(item) => <div>
                            {item.nome} <span className="text-muted-foreground text-xs">{item.codigo}</span>
                        </div>
                        }
                        nullValue
                        filter
                        onChange={(e) => setCampo("motoristaId", e.target.value)}
                        placeholder="Selecione o motorista"
                        showClear
                        error={errosV.motorista === true ? "Motorista Vinculado em Outra Carga" : null || erros}
                        touched={erros}

                    />
                </div>
                <div className="md:col-span-4">
                    <Multiselect
                        value={form.auxiliares}
                        label="Auxiliares"
                        options={auxiliares}
                        optionLabel="nome"
                        onChange={(e) => setCampo('auxiliares', e.value)}
                        itemTemplate={(item) => <div>
                            {item.nome} <span className="text-muted-foreground text-xs">{item.codigo}</span>
                        </div>
                        }
                        multiple
                        filter
                        className="w-full"
                        showClear
                        max={2}
                        filterBy="nome,codigo"
                        error={errosV.auxiliares === true ? "Auxiliar Vinculado em Outra Carga" : null || erros}
                        touched={erros}
                    />
                </div>
                <div className="md:col-span-2">
                    <Input
                        label="Área"
                        value={form.area}
                        onChange={e => setCampo("area", e.target.value)}
                        error={form.area === null || erros}
                        touched={erros}
                    />
                </div>
                <Input
                    label="Total Entregas"
                    type="number"
                    value={form.totalEntregas || ""}
                    onChange={e => setCampo("totalEntregas", e.target.value)}
                    error={form.totalEntregas === null || erros}
                    touched={erros}
                />

                <Input
                    label="Volume"
                    type="number"
                    value={form.volume || ""}
                    onChange={e => setCampo("volume", e.target.value)}
                />

                <Input
                    label="Cubos"
                    type="number"
                    value={form.cubos || ""}
                    onChange={e => setCampo("cubos", e.target.value)}
                    error={form.cubos === null || erros}
                    touched={erros}
                />

                <Input
                    label="Capacidade Cubos"
                    type="number"
                    value={form.capCubos || ""}
                    onChange={e => setCampo("capCubos", e.target.value)}
                />

                <Input
                    label="Distância Planejada"
                    type="number"
                    value={form.distanciaPlanejada || ""}
                    onChange={e => setCampo("distanciaPlanejada", e.target.value)}
                />

                <Input
                    label="Ocupação"
                    type="number"
                    value={form.ocupacao || ""}
                    onChange={e => setCampo("ocupacao", e.target.value)}
                />

                <InputFormat
                    label="Tempo Total"
                    mask="99:99:99"
                    value={form.tempoTotal || ""}
                    onChange={e => setCampo("tempoTotal", e)}
                />

                <div className="col-span-3">
                    <div className="flex flex-col">
                        <label
                            className={`text-sm font-medium text-foreground`}>
                            Tipo de Rota
                        </label>
                    </div>

                    <div className="flex items-center gap-3">
                        <ButtonRadio
                            label="24 Horas"
                            checked={form.tipoRota === "DIARIA"}
                            onChange={e => setCampo("tipoRota", "DIARIA")}
                        />
                        <ButtonRadio
                            label="48 Horas"
                            checked={form.tipoRota === "DOIS_DIAS"}
                            onChange={e => setCampo("tipoRota", "DOIS_DIAS")}
                        />
                        <ButtonRadio
                            label="AS+"
                            checked={form.tipoRota === "AS"}
                            onChange={e => setCampo("tipoRota", "AS")}
                        />
                        <ButtonRadio
                            label="Recarga"
                            checked={form.tipoRota === "RECARGA"}
                            onChange={e => setCampo("tipoRota", "RECARGA")}
                        />
                        <ButtonRadio
                            label="Frete"
                            checked={form.tipoRota === "FRETE"}
                            onChange={e => setCampo("tipoRota", "FRETE")}
                        />
                        <ButtonRadio
                            label="Reprogramação"
                            checked={form.tipoRota === "REPROGRAMACAO"}
                            onChange={e => setCampo("tipoRota", "REPROGRAMACAO")}
                        />

                    </div>
                </div>
            </div>

            {/* Botões */}
            <div className="flex justify-end border-t border-border items-end">

                <div className="flex justify-end gap-3 items-end pt-3">
                    <Button
                        label="Cancelar"
                        variant="gray"
                        onClick={onClose}
                        iconLeft="fa fa-arrow-left"
                    />

                    <Button
                        label="Salvar"
                        variant="indigo"
                        loading={loading}
                        onClick={handleSalvar}
                        iconLeft="fa fa-save"
                    />
                </div>
            </div>
        </div>
    );
}

export default CadastrarEscalaRota;
